import { render, staticRenderFns } from "./OfferAttribute.vue?vue&type=template&id=ded6a236"
import script from "./OfferAttribute.vue?vue&type=script&lang=js"
export * from "./OfferAttribute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports